import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
const NAMES = ['Marina', 'Lucía', 'Verónica', 'Florencia', 'Andrea', 'Cecilia', 'Mónica', 'Belén', 'Agustina', 'Natalia', 'Paula', 'Julieta', 'Rocío', 'Mariana', 'Estefanía', 'Carla', 'Analía', 'Micaela', 'Guadalupe', 'Sabrina'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Juan', 'Paraná', 'Corrientes', 'San Luis', 'Río Cuarto', 'Comodoro Rivadavia', 'San Salvador de Jujuy'];
const MINUTES = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 14 minutos', 'hace 21 minutos'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface Sale {
  id: number;
  name: string;
  city: string;
  when: string;
}
export function SocialProofPopup() {
  const [sale, setSale] = useState<Sale | null>(null);
  const showNext = useCallback(() => {
    setSale({
      id: Date.now(),
      name: pick(NAMES),
      city: pick(CITIES),
      when: pick(MINUTES)
    });
  }, []);
  useEffect(() => {
    const firstTimer = window.setTimeout(showNext, 4500);
    return () => window.clearTimeout(firstTimer);
  }, [showNext]);
  useEffect(() => {
    if (!sale) return;
    // auto-hide, then schedule the next one
    const hide = window.setTimeout(() => setSale(null), 6000);
    const next = window.setTimeout(showNext, 6000 + 12000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [sale, showNext]);
  return <div className="pointer-events-none fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] sm:max-w-sm" data-id="element-148">
      <AnimatePresence data-id="element-149">
        {sale && <motion.div key={sale.id} role="status" aria-live="polite" initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 22
      }} className="pointer-events-auto flex items-start gap-3 rounded-2xl border border-sage/30 bg-white p-4 pr-9 shadow-2xl shadow-ink/10" data-id="element-150">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sage/15" data-id="element-151">
              <CheckCircle2Icon className="h-5 w-5 text-sage-deep" aria-hidden="true" data-id="element-152" />
            </div>
            <div className="min-w-0" data-id="element-153">
              <p className="text-sm font-semibold leading-snug text-ink" data-id="element-154">
                {sale.name}, de {sale.city}
              </p>
              <p className="text-sm leading-snug text-ink/70" data-id="element-155">
                acaba de comprar Mega Pack Tiroides
              </p>
              <p className="mt-1 text-xs font-medium text-sage-deep" data-id="element-156">
                Compra verificada · {sale.when}
              </p>
            </div>
            <button type="button" onClick={() => setSale(null)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded-full p-1 text-ink/40 transition-colors hover:bg-cream hover:text-ink/70" data-id="element-157">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-158" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}